import { isEqual } from 'lodash';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { ComponentStylingInterface, HTMLComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

const TicketcodeStyling = ({ component, onChange }: ComponentStylingInterface<HTMLComponentInterface>) => {
  const [currComponent, setCurrComponent] = useState(component);
  const { t } = useTranslation('pagebuilder');

  useEffect(() => {
    setCurrComponent(component);
  }, [component]);

  return <PageBuilderSettingsTable component={currComponent} onChange={onChange} sections={[]} showTitleAndDescription={false} />;
};
export default React.memo(TicketcodeStyling, (prevprop, newprop) => isEqual(prevprop, newprop));
